(() => {
  const desktop = window.matchMedia('(min-width: 1024px)');

  function closeOpenMenus(navigation) {
    if (!desktop.matches) return;

    navigation
      .querySelectorAll('details[data-navmenu-details][open]')
      .forEach((details) => {
        details.open = false;
        const summary = details.querySelector(':scope > summary');
        if (summary) {
          summary.setAttribute('aria-expanded', 'false');
          const resetExpandedState = () => {
            summary.setAttribute('aria-expanded', 'false');
          };
          window.requestAnimationFrame(resetExpandedState);
          window.setTimeout(resetExpandedState, 100);
        }
      });
  }

  function bindNavigation(root = document) {
    root.querySelectorAll('.site-navigation').forEach((navigation) => {
      if (navigation.dataset.lecceHoverCloseBound === 'true') return;
      navigation.dataset.lecceHoverCloseBound = 'true';

      navigation.addEventListener('pointerleave', () => {
        closeOpenMenus(navigation);
      });

      navigation.addEventListener('focusout', (event) => {
        if (!navigation.contains(event.relatedTarget)) {
          closeOpenMenus(navigation);
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => bindNavigation());
  } else {
    bindNavigation();
  }

  document.addEventListener('shopify:section:load', (event) => {
    bindNavigation(event.target);
  });
})();
